/** First argument whose trimmed value is non-empty; '' when none. */
export function firstNonBlank(...values: Array<string | null | undefined>): string {
  for (const value of values) {
    const normalized = `${value ?? ''}`.trim();
    if (normalized) {
      return normalized;
    }
  }
  return '';
}
